import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=2feac290&scoped=true"
import script from "./Approval.vue?vue&type=script&lang=js"
export * from "./Approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feac290",
  null
  
)

export default component.exports